import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import { tableName } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
    importTemplates,
    exportTemplates,
  },
  props: {
    tabKey: String,
    type: String,
    role: String,
    screenId: Number,
    columnSettings: Array,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'contract') {
        const reg = /^(?!$)\d{0,8}(?:\.\d{1,2})?$/
        if (!reg.test(value)) {
          callback(
            new Error('Please enter valid contract # (For e.g.:  12345678.12)'),
          )
        } else {
          callback()
        }
      } else {
        if (String(value).length > 100) {
          callback(
            new Error('Contract must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'contract',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      contractList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        contract: undefined,
        contract_Name: undefined,
        isActive: 1,
      },
      rules: {
        contract: [
          {
            required: true,
            message: 'Please enter contract #',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        contract_Name: [
          { required: true, message: 'Please enter contract', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      exportClicked: false,
      uploadedFile: null,
      importClicked: false,
      importColDef: gridProperties.import.columns.contract,
      loadImport: false,
      tableState: null,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: gridProperties.master.columns.contract,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'))
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteContract', this.deleteContract)
    this.$root.$on('editContract', this.getContractById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '14') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.contractList = []
        this.loading = true
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editContract')
    this.$root.$off('deleteContract')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      gridProperties.master.columns.contract.map(i => {
        if (i.field === 'action' || i.field === 'isActive' || !i.field) {
          i.hide = this.type === 'Template'
        }
      })
    },

    // Refresh Contracts
    refreshContracts() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.contractList = []
      this.page = 0
      this.defaultSortedBy = 'contract'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'contract',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getContracts(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Contract
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Contract'
      this.form.contract = undefined
      this.form.id = null
      this.form.contract_Name = null
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save Contract
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.contract.add
          let method = 'post'
          const req = {
            contract: this.form.contract,
            contractName: this.form.contract_Name,
          }
          if (this.form.id) {
            method = 'patch'
            url = masterAPIs.contract.details(this.form.id)
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id ? 'Update Contract' : 'Create Contract',
                this.form.id
                  ? 'Contract updated successfully!'
                  : 'Contract created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.contractList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.contractList = newData
              } else {
                this.getContracts(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load Contracts
    getContracts(params, type) {
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        contract: _.get(this.filters, 'contract', undefined),
        contractName: _.get(this.filters, 'contractName', undefined),
      }
      instance
        .post(masterAPIs.contract.list, req)
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.contractList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'contractTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Contract By Id
    getContractById(id, record) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(masterAPIs.contract.details(id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.contract = _.get(response.data, 'result.contract', null)
          this.form.contract_Name = _.get(
            response.data,
            'result.contractName',
            null,
          )
          this.form.isActive = _.get(
            response.data,
            'result.isActive',
            record.isActive,
          )
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.contract.delete, req)
        .then(response => {
          showNotification(
            'success',
            'Delete Contract',
            'Contract deleted successfully!',
          )
          this.refreshContracts()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Contracts
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected contracts ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              contracts
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Contract
    deleteContract(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.contract} - ${data.contract_Name}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this contract
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    checkboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    headerCheckboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.contractList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'contract'
        this.defaultSortOrder = true
      }
      this.getContracts(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'contractTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.contractList = []
      this.selectedRowKeys = []
      this.getContracts(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.contractList = []
      this.getContracts(this.gridOptions)
    },

    // exportClicked
    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    updateTable() {
      this.importClicked = false
      this.refreshContracts()
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshContracts()
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: !this.type ? screenType.contract : undefined,
          screenId: this.type ? this.screenId : undefined,
          tableName: this.type ? tableName.template.master.contract : undefined,
          columnDetails: JSON.stringify(this.tableState),
        }
        if (!this.type) {
          this.$emit('updateColumns', request)
        } else {
          this.$emit('updateColumnSettings', request)
        }
      }
    },

    getColumnSettings(params) {
      if (this.type) {
        const columnDetails = this.columnSettings.find(
          i =>
            i.screenId === this.screenId &&
            i.tableName === tableName.template.master.contract,
        )
        this.setColumnSettings(
          params,
          columnDetails ? columnDetails.columnDetails : null,
        )
        this.getContracts(this.gridOptions)
      } else {
        if (this.role === 'Admin') {
          instance
            .get(masterAPIs.columnSetting.get(screenType.contract))
            .then(response => {
              const tableState = _.get(
                response.data,
                'result.columnDetails',
                null,
              )
              this.setColumnSettings(params, tableState)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        } else {
          this.setColumnSettings(params)
        }
        this.getContracts(this.gridOptions)
      }
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = !!this.type
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'contract'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'contract',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin' || this.type === 'Template',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
